import "@hotwired/turbo"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import Trix from "trix"
import "@rails/actiontext"
import { getDefaultHTML } from "#/layouts/js/trix_toolbar"
Trix.config.toolbar["getDefaultHTML"] = getDefaultHTML

import "#/layouts/js"
import "#/listings/js"
import "#/pages/js"
import "#/registrations/js"
import "#/admin/events/js"
import "#/admin/weekends/js"
